import React, { ReactElement, ReactNode, useEffect, useRef, useState } from 'react';
import './KodanshaCheckBox.scss';

interface Props {
    label?: string | JSX.Element;
    ariaLabel?: string;
    checked?: boolean;
    onChange?: (e) => void;
    useAnimation?: boolean;
    controlled?: boolean;
}

const KodanshaCheckBox = ({ label = 'label', ariaLabel = 'label', checked = true, onChange, controlled = false }: Props) => {
    const inputId = useRef(`${label}-input-${Math.random()}`);
    const [active, setActive] = useState(checked);
    const animatedRef = useRef(null);
    /*    if (active != checked){
            setActive(checked);
            console.log("setting checked to " + checked);
        }*/

    const onInputChanged = () => {
        onChange(!active);
        setActive(active => !active);
    };

    useEffect(() => {
        animatedRef.current.classList.add('checkmark-animation');
    }, [animatedRef]);

    return (
        <div className='ui-checkbox-container' aria-label={typeof label === 'string' ? label : ariaLabel}>
            <label htmlFor={inputId.current} onClick={onInputChanged} className='checkbox-label'>
                {label}
            </label>
            <input id={inputId.current} name={inputId.current}
                   aria-label={'checkbox for ' + (typeof label === 'string' ? label : ariaLabel)}
                   className='checkbox-input' type='checkbox'
                   checked={controlled ? checked : active}
                   onChange={(event): void => {
                       event.preventDefault();
                   }} />
            <span ref={animatedRef} onClick={onInputChanged} className='checkmark'>
            </span>
        </div>
    );
};

export default KodanshaCheckBox;

interface OtherProps {
    checkboxProps:React.ComponentPropsWithoutRef<"input">,
    labelProps:React.ComponentPropsWithoutRef<"label">,
    checkboxSpanProps?:React.ComponentPropsWithoutRef<"span">,
    commonLabel:ReactNode
    commonOnChange?:()=>void
}
export const OtherKodanshaCheckBox = ({ commonLabel = 'label',commonOnChange, ...rest}: OtherProps) => {
    const inputId = useRef(`${commonLabel}-input-${Math.random()}`);

    const animatedRef = useRef(null);
    
    useEffect(() => {
        animatedRef.current.classList.add('checkmark-animation');
    }, [animatedRef]);
    


    return (
        <div className='ui-checkbox-container' aria-label={commonLabel.toString()}>
            <label htmlFor={inputId.current} className='checkbox-label' {...rest.labelProps}>
                {commonLabel}
            </label>
            <input 
                id={inputId.current} name={inputId.current}//this is what fills in the checkbox
                   aria-label={'checkbox for ' + commonLabel}
                   className='checkbox-input' type='checkbox'
                   onChange={commonOnChange}
                   {...rest.checkboxProps}
            />
            <span ref={animatedRef} 
                  onClick={commonOnChange} //this is what actually gets clicked most of the time
                  className='checkmark'
                  {...rest.checkboxSpanProps}
            >
            </span>
        </div>
    );
};